const editRegulationsRequestsStatusDictionary = {
  1: {
    text: "تحت المعالجة",
    badgeColor: "blue",
  },
  2: {
    text: "مرفوض",
    badgeColor: "red",
  },
  3: {
    text: "معتمد",
    badgeColor: "green",
  },
};
export default editRegulationsRequestsStatusDictionary;
